import PropTypes from 'prop-types';
import { Link as RouterLink } from 'react-router-dom';
// @mui
import { useTheme } from '@mui/material/styles';
import { Box } from '@mui/material';

// -----------------------------------------------------------

Logo.propTypes = {
  disabledLink: PropTypes.bool,
  sx: PropTypes.object,
};

export default function Logo({ disabledLink = false, sx }) {
  const theme = useTheme();
  const PRIMARY_LIGHT = theme.palette.primary.light;
  const PRIMARY_MAIN = theme.palette.primary.main;
  const PRIMARY_DARK = theme.palette.primary.dark;
  const logo = (
    <Box sx={{ width: 40, height: 40, ...sx }}>
      <svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" viewBox="0 0 1080.000000 1080.000000">
        <defs>
          <linearGradient id="BG1" x1="100%" x2="50%" y1="9.946%" y2="50%">
            <stop offset="0%" stopColor={PRIMARY_DARK} />
            <stop offset="100%" stopColor={PRIMARY_MAIN} />
          </linearGradient>
          <linearGradient id="BG2" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stopColor={PRIMARY_LIGHT} />
            <stop offset="100%" stopColor={PRIMARY_MAIN} />
          </linearGradient>
          <linearGradient id="BG3" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stopColor={PRIMARY_LIGHT} />
            <stop offset="100%" stopColor={PRIMARY_MAIN} />
          </linearGradient>
        </defs>
        <g
          fill={PRIMARY_MAIN}
          stroke="none"
          strokeWidth="1"
          fillRule="evenodd"
          transform="translate(0.000000,1080.000000) scale(0.100000,-0.100000)"
        >
          <path
            d="M4978 10505 c-531 -51 -1074 -192 -1563 -408 -179 -79 -473 -235
-582 -309 -23 -15 -44 -28 -47 -28 -2 0 -71 -46 -153 -102 -462 -316 -835
-673 -1190 -1138 -106 -140 -298 -428 -364 -549 -11 -20 -40 -72 -65 -116 -94
-168 -252 -506 -310 -665 -157 -431 -248 -793 -299 -1195 -80 -630 -42 -1242
117 -1870 107 -424 318 -953 489 -1226 16 -25 29 -49 29 -52 0 -4 23 -44 51
-90 255 -407 433 -632 753 -953 844 -844 1892 -1362 3036 -1500 182 -21 679
-30 880 -15 742 56 1475 291 2135 684 677 403 1271 964 1685 1592 103 155 111
169 172 275 293 510 491 1057 592 1640 118 678 91 1435 -74 2115 -70 285 -152
527 -301 885 -41 98 -206 423 -275 541 -107 184 -305 474 -425 624 -152 190
-218 264 -397 445 -675 685 -1522 1141 -2472 1334 -148 30 -211 40 -425 67
-214 27 -779 35 -997 14z m887 -235 c627 -60 1290 -265 1820 -563 249 -140
553 -349 734 -506 143 -123 379 -351 466 -451 174 -198 222 -258 354 -445 93
-130 241 -357 241 -369 0 -2 25 -46 56 -97 73 -122 195 -372 278 -573 180
-432 297 -895 353 -1391 28 -250 26 -836 -4 -1080 -80 -650 -264 -1225 -571
-1785 -48 -87 -187 -309 -248 -394 -27 -38 -61 -86 -76 -107 -56 -79 -258
-327 -334 -409 -913 -983 -2086 -1546 -3333 -1599 -473 -19 -879 25 -1356 149
-627 162 -1274 493 -1809 925 -109 88 -125 101 -236 199 -117 104 -387 387
-501 526 -239 291 -414 558 -579 885 -252 497 -415 1030 -490 1600 -133 1004
88 2085 616 3017 99 174 304 486 393 598 16 19 59 73 97 120 476 594 1134
1093 1829 1387 444 188 870 299 1358 353 100 11 209 22 242 24 103 7 585 -3
700 -14z"/>
<path d="M3194 8650 c-110 -22 -234 -92 -323 -181 -93 -94 -139 -173 -170
-295 -20 -78 -20 -116 -23 -2269 l-2 -2190 22 -79 c60 -215 218 -379 437 -454
l80 -27 2055 -3 c1382 -2 2085 0 2146 7 227 26 423 162 515 355 75 157 69 -44
69 2397 l0 2197 -23 78 c-42 147 -139 284 -252 359 -69 46 -168 90 -233 104
-63 13 -4231 14 -4298 1z m4276 -141 c178 -41 340 -206 379 -387 18 -84 15
-4370 -3 -4437 -35 -131 -145 -274 -254 -329 -117 -59 35 -55 -2252 -58 -2011
-3 -2097 -2 -2155 15 -136 42 -253 143 -314 272 -21 44 -42 98 -46 120 -13 69
-6 4361 7 4414 44 179 164 311 342 377 l61 23 2095 0 c1403 0 2110 -3 2140
-10z"/>
<path d="M6580 8283 c-21 -9 -30 -24 -30 -55 0 -45 20 -54 132 -61 56 -4 129
-14 162 -22 107 -29 230 -93 301 -157 17 -14 44 -39 62 -55 51 -46 132 -161
170 -242 42 -89 83 -246 83 -318 0 -43 4 -55 25 -71 28 -23 59 -19 78 9 10 13
11 40 5 104 -36 414 -361 780 -758 854 -73 13 -211 22 -230 14z"/>
<path d="M6566 8014 c-18 -17 -21 -61 -7 -83 7 -11 39 -17 108 -21 140 -10
246 -55 347 -149 106 -100 185 -260 186 -376 1 -83 51 -125 96 -80 24 24 25
30 19 93 -10 89 -44 195 -90 279 -55 99 -188 228 -286 276 -138 68 -334 100
-373 61z"/>
<path d="M6566 7754 c-22 -21 -21 -71 2 -82 9 -5 47 -12 84 -15 162 -15 274
-123 297 -288 8 -64 20 -79 62 -79 35 0 49 18 49 65 0 131 -83 277 -199 350
-97 60 -257 87 -295 49z"/>
<path d="M6580 7482 c-37 -36 -40 -43 -40 -93 0 -94 53 -149 142 -149 59 0
105 30 127 83 27 62 18 110 -30 158 -37 37 -43 39 -99 39 -55 0 -62 -3 -100
-38z"/>
<path d="M4186 7181 c-4 -5 -33 -74 -65 -153 -84 -206 -157 -382 -346 -833
-92 -220 -180 -431 -195 -470 -38 -95 -149 -365 -258 -625 -49 -118 -135 -325
-191 -460 -56 -135 -113 -270 -126 -301 -14 -31 -25 -62 -25 -68 0 -8 84 -11
312 -9 l311 3 99 250 c54 138 103 260 108 273 l10 22 404 0 405 0 5 -52 c11
-103 46 -414 52 -455 l5 -43 308 0 c169 0 310 2 313 5 2 3 -15 157 -38 342
-24 186 -77 608 -119 938 -41 330 -89 706 -105 835 -17 129 -37 291 -46 360
-8 69 -24 195 -34 280 -11 85 -20 158 -20 163 0 10 -758 9 -764 -2z m314
-1108 c22 -208 46 -448 55 -533 8 -85 16 -168 18 -185 l2 -29 -279 2 c-154 1
-280 3 -281 5 -1 1 71 187 159 412 89 226 188 479 220 563 33 83 61 150 64
148 2 -3 21 -175 42 -383z"/>
<path d="M5756 7128 c-11 -96 -91 -666 -207 -1468 -22 -151 -48 -338 -59 -415
-10 -77 -35 -250 -55 -385 -58 -397 -85 -584 -85 -593 0 -5 235 -7 523 -4 489
4 528 5 615 25 162 38 332 117 462 217 287 221 511 643 594 1120 93 528 41
922 -155 1186 -136 184 -321 298 -568 351 -88 19 -138 21 -577 25 l-481 4 -7
-63z m856 -513 c196 -41 320 -160 370 -356 18 -75 20 -103 15 -259 -10 -335
-98 -662 -244 -910 -37 -63 -178 -199 -240 -233 -91 -49 -188 -67 -356 -67
l-149 0 5 30 c4 16 29 191 57 387 28 197 66 459 85 583 19 124 53 358 76 520
22 162 42 301 44 308 6 18 244 16 337 -3z"/>
<path d="M2417 2743 c-9 -21 -39 -101 -66 -178 -28 -77 -86 -237 -129 -355
-44 -118 -78 -218 -75 -222 8 -14 180 -9 190 5 6 6 20 43 33 80 l22 68 146 -3
145 -3 24 -77 24 -78 99 0 c55 0 100 2 100 4 0 3 -80 232 -121 346 -10 30 -52
143 -92 250 l-73 195 -105 3 -106 3 -16 -38z m168 -306 c22 -67 41 -128 43
-134 3 -10 -20 -13 -87 -13 -66 0 -91 3 -91 12 0 21 81 258 88 258 4 0 25 -55
47 -123z"/>
<path d="M3050 2380 l0 -402 228 4 c211 3 231 5 277 26 63 29 93 56 116 107
22 48 25 133 5 178 -16 38 -66 87 -104 102 l-27 12 25 13 c101 54 117 216 28
296 -60 55 -77 59 -320 62 l-228 4 0 -402z m392 220 c25 -25 29 -35 23 -63
-10 -46 -36 -64 -108 -72 -110 -12 -112 -11 -115 69 -2 38 -1 75 2 83 4 9 28
13 86 13 77 0 83 -2 112 -30z m30 -310 c26 -27 30 -36 25 -68 -4 -22 -17 -46
-33 -60 -24 -21 -34 -22 -122 -20 l-97 3 -3 88 -3 87 101 0 c100 0 102 -1 132
-30z"/>
<path d="M3848 2383 l4 -398 181 -3 c203 -3 292 8 353 43 111 65 139 225 56
316 -19 22 -49 46 -65 52 l-29 12 38 25 c56 36 82 110 65 186 -15 63 -47 106
-105 137 -38 20 -57 22 -271 25 l-231 4 4 -399z m371 232 c32 -16 41 -33 41
-74 0 -45 -31 -68 -103 -76 -113 -12 -112 -13 -115 83 l-3 82 76 0 c47 0 87
-6 104 -15z m46 -320 c35 -34 34 -93 -1 -129 -25 -25 -32 -26 -125 -26 l-99 0
0 90 0 90 100 0 c94 0 103 -2 125 -25z"/>
<path d="M4806 2623 c-31 -87 -97 -264 -145 -393 -49 -129 -86 -238 -84 -242
7 -14 180 -9 191 5 5 6 18 39 28 72 10 33 23 63 29 67 5 4 69 8 140 8 72 0
135 -4 141 -8 6 -4 21 -38 35 -77 l24 -70 94 -3 c52 -1 97 1 101 5 4 4 -5 40
-20 78 -16 39 -81 215 -146 393 l-117 322 -107 0 -107 0 -57 -157z m213 -194
c23 -69 41 -129 41 -132 0 -4 -40 -7 -90 -7 -49 0 -90 3 -90 8 0 21 86 270 92
264 3 -4 25 -64 47 -133z"/>
<path d="M5760 2380 l0 -403 198 5 c159 5 209 9 258 25 113 37 187 104 234
213 21 47 24 71 24 160 0 140 -23 200 -108 286 -96 97 -131 107 -393 112
l-213 4 0 -402z m381 225 c88 -30 130 -92 137 -203 11 -165 -73 -251 -245
-252 l-83 0 0 235 0 235 73 0 c40 0 94 -7 118 -15z"/>
<path d="M6829 2753 c-6 -15 -42 -116 -81 -223 -55 -153 -165 -456 -195 -537
-4 -10 18 -13 90 -13 104 0 107 2 126 65 7 22 17 52 23 68 l10 27 138 0 c156
0 152 2 176 -81 9 -30 21 -60 26 -66 12 -16 198 -18 198 -3 0 10 -69 200 -199
550 l-88 235 -107 3 -106 3 -11 -28z m131 -208 c0 -8 18 -67 40 -131 22 -65
40 -119 40 -121 0 -1 -40 -3 -90 -3 -60 0 -90 4 -90 11 0 6 16 64 36 128 20
64 38 122 40 129 5 17 24 6 24 -13z"/>
<path d="M7320 2700 l0 -80 110 0 110 0 2 -317 3 -318 95 0 94 0 1 315 0 315
113 3 112 3 0 79 0 80 -320 0 -320 0 0 -80z"/>
<path d="M8206 2748 c-8 -18 -44 -116 -81 -218 -37 -102 -79 -214 -92 -250
-45 -119 -103 -285 -103 -293 0 -4 44 -6 98 -5 l97 3 26 75 26 75 143 0 c161
0 146 8 181 -92 l22 -63 92 0 c50 0 94 3 97 6 3 3 0 22 -8 42 -14 39 -70 192
-172 472 -33 91 -70 191 -82 223 l-21 57 -105 0 -105 0 -13 -32z m166 -316
c21 -63 38 -120 38 -128 0 -11 -19 -14 -91 -14 -69 0 -90 3 -87 13 3 6 22 64
42 127 21 63 40 122 43 130 6 18 1 31 55 -128z"/>
</g>
</svg>
    </Box>
  );
  if (disabledLink) {
    return <>{logo}</>;
  }

  return <RouterLink to="">{logo}</RouterLink>;
}
